const Cookie = require("js-cookie");

exports.set = function set(key, value, options = {}) {
  return Cookie.set(key, value, options);
};

exports.get = function get(key) {
  return Cookie.get(key);
};
